enum HttpMethod {
  GET = 'GET',
  POST = 'POST',
}

export { HttpMethod }
